import { render, staticRenderFns } from "./BilletFranchise.vue?vue&type=template&id=09621da3&"
import script from "./BilletFranchise.vue?vue&type=script&lang=js&"
export * from "./BilletFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports